<template>
    <div class="kay-data-table">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="row">
              <div class="col-md-12">
                <div class="card-section">
                    <div class="card-header">
                        <h4 class="card-title">串接Key設定</h4>
                    </div>
                    <div class="card-body">
                        <div v-for="(key, index) in keys" :key="index" class="key-secret-block">
                        <div class="key-secret-pair">
                            <span class="key-secret-label">App ID</span>
                            <span class="key-secret-data">{{key.clientId}}</span>
                        </div>
                        <div class="key-secret-pair">
                            <span class="key-secret-label">App Key</span>
                            <span class="key-secret-data">{{key.clientSecret}}</span>
                            <span v-if="index === keys.length - 1" class="key-secret-button">
                                <button @click="generateAppKeys" class="btn btn-primary" :disabled="isGenerateKeysDisabled">生成點點開發者Key</button>
                            </span>
                        </div>
                        <hr v-if="index < keys.length - 1" class="key-secret-divider"/>  <!-- 每組 key, secret 之間的分隔線，最後一項不顯示 -->
                        </div>
                    </div>
                </div>

                <div class="section-divider"></div>

                <div class="card-section">
                    <div class="card-body">
                        <div class="auth-key-block mt-4">
                        <div class="key-secret-pair">
                            <span class="key-secret-label">Lafresh AuthKey</span>
                            <input v-model="lafreshAuthKey" type="text" class="key-secret-data">
                        </div>
                        <div class="key-secret-pair">
                            <span class="key-secret-label">Short ID</span>
                            <span class="key-secret-data">{{ shortId }}</span>
                            <span class="key-secret-button">
                                <button @click="generateShortId" class="btn btn-primary" :disabled="isGenerateShortIdDisabled">生成Lafresh會員串接Key</button>
                            </span>
                        </div>
                        </div>
                    </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    data() {
        return {
            keys: [{ clientId: '', clientSecret: '' }],
            lafreshAuthKey: '',
            shortId: null
        };
    },
    methods: {
        async getAppKeys() {
            const siId = this.$route.params.siId;
            try {
                const response = await axios.get(`${process.env.VUE_APP_APIHOST}/gaa/si-accounts/${siId}/app-keys`)

                if (response.data.length === 0) {
                    this.keys = [{ clientId: '', clientSecret: '' }];
                } else {
                    this.keys = response.data;
                }
            } catch (error) {
                console.log("Failed to get SI app keys:", error);
                this.keys = [{ clientId: '', clientSecret: '' }];
            };
        },

        async getShortId() {
            const siId = this.$route.params.siId;
            try {
                const response = await axios.get(`${process.env.VUE_APP_APIHOST}/gaa/si-accounts/${siId}/lockline`);
                this.shortId = response.data;
            } catch (error) {
                console.error("Failed to get Short ID:", error);
            }
        },

        async generateAppKeys() {
            const siId = this.$route.params.siId;
            try {
                const response = await axios.post(`${process.env.VUE_APP_APIHOST}/gaa/si-accounts/${siId}/app-keys`);
                await this.getAppKeys();

            } catch (error) {
                console.error("Failed to generate app key and secret:", error);
            }
        },

        async generateShortId() {
            const siId = this.$route.params.siId;
            try {
                const response = await axios.post(`${process.env.VUE_APP_APIHOST}/gaa/si-accounts/${siId}/lockline`, {
                    authKey: this.lafreshAuthKey,
                });

                this.shortId = response.data.shortId;
                await this.getShortId();
            } catch (error) {
                console.error("Failed to generate Short ID:", error);
            }
        }

    },
    computed: {
        isGenerateKeysDisabled() {
            return this.keys.length > 0 && this.keys[0].clientId !== '';
        },
        isGenerateShortIdDisabled() {
            return !this.lafreshAuthKey; // 如果lafreshAuthKey為空，則不能點擊按鈕
        }
    },
    mounted() {
        this.getAppKeys();
        this.getShortId();
    }
};
</script>

<style>
.key-secret-pair {
  display: flex;
  align-items: center;
  padding: 4px;
  margin-bottom: 1px;
}

.key-secret-label {
  flex-basis: 10%;
  text-align: right;
}

.key-secret-data {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 6px;
  border: 1px solid #aaaaaa;
  border-radius: 4px;
  text-align: left;
  margin-left: 20px;
  width: 45%;
  height: 30px;
}

.key-secret-divider {
  border-top: 1px solid #dcdde2;
  margin-top: 20px;
  margin-bottom: 20px;
}

.card-section {
  background-color: #ffffff;
  margin-bottom: 20px;
}

.section-divider {
  height: 20px;
  background-color: #dcdde2;
}

.key-secret-button {
  margin-left: auto;
  padding-left: 10px;
}

.btn-primary {
  margin-right: 8%;
  width: 190px;
}
</style>